/* eslint-disable no-redeclare */
import { ethers } from "ethers";
import { getStakingContract } from ".";
import tokenABI from '../contracts/Token.json'
// import stakingContractABI from '../contracts/Staking.json';

// In config.js
export const babyDracTokenAddress = "0xCb7b6BacDA7aAa73fd1D02ab2AEe9F2a09B6CcC6";
export const stakingContractAddress = "0xAD509AD73dF3961B79D716Eb264848C212A1b229";


export function isAddress(address) {
    try {
        ethers.utils.getAddress(address);
    } catch (e) { return false; }
    return true;
}

export async function resolveName(name) {
    try {
        const provider = new ethers.providers.JsonRpcProvider(process.env.REACT_APP_RPC);
        var address = await provider.resolveName(name);
        return address;
    } catch (e) { return ''; }    
}

export function toEth(amount, decimal) {
    return ethers.utils.formatUnits(String(amount), decimal);
}

export function toWei(amount, decimal) {
    return ethers.utils.parseUnits(String(amount), decimal);
}



// Function to fetch DRAC24 rewards
export async function fetchDRAC24Rewards(userAddress) {
    const contract = getStakingContract();
    try {
      const rewards = await contract.available(userAddress);
      return ethers.utils.formatEther(rewards); // Converts the rewards from Wei to Ether
    } catch (e) {
      console.error("Error fetching DRAC24 Rewards:", e);
      return null;
    }
  }

  // Function to fetch Days Per Period
// export async function fetchDaysPerPeriod() {
//     const contract = getStakingContract();
//     try {
//       const days = await contract.daysPerPeriod();
//       return days.toString(); // Converts BigNumber to string
//     } catch (e) {
//       console.error("Error fetching Days Per Period:", e);
//       return null;
//     }
//   }

  // Function to fetch user's balance of Baby Drac tokens
export async function fetchBabyDracBalance(userAddress) {
    const contract = getStakingContract();
    try {
      const balance = await contract.balanceOf(userAddress);
      return ethers.utils.formatEther(balance); // Converts the balance from Wei to Ether
    } catch (e) {
      console.error("Error fetching Baby Drac Balance:", e);
      return null;
    }
  }

  export async function fetchTotalBabyDracBalance(userAddress, provider) {
    if (!provider) {
        console.error("Provider is not initialized.");
        return null;
    }
    if (!userAddress) {
        console.error("User address is undefined.");
        return null;
    }

    try {
        const tokenContract = new ethers.Contract(babyDracTokenAddress, tokenABI, provider);
        if (!tokenContract) {
            console.error("Failed to create token contract instance.");
            return null;
        }

        const balance = await tokenContract.balanceOf(userAddress);
        return ethers.utils.formatEther(balance);
    } catch (e) {
        console.error("Error fetching total Baby Drac Balance:", e);
        return null;
    }
}

  
  
  
  // Function to stake tokens
export async function stakeTokens(amount, provider) {
    const contract = getStakingContract(provider);
    try {
      const amountInWei = ethers.utils.parseEther(amount.toString());
      const tx = await contract.stake(amountInWei);
      await tx.wait();
      console.log("Staked successfully!");
    } catch (e) {
      console.error("Error staking tokens:", e);
    }
  }

// Function to approve spending of tokens
  export async function approveTokenSpending(tokenContractAddress, spenderAddress, amount, signer) {
    try {
      const tokenContract = new ethers.Contract(tokenContractAddress, tokenABI, signer);
      const amountInWei = ethers.utils.parseUnits(amount.toString(), 'ether'); // Convert amount to WEI
      const tx = await tokenContract.approve(spenderAddress, amountInWei);
      await tx.wait();
      console.log("Approval successful!");
    } catch (e) {
      console.error("Error approving tokens:", e);
    }
  }

  // In your utilities/contracts file
export async function fetchAllowance(ownerAddress, spenderAddress, tokenContractAddress, signer) {
    try {
      const tokenContract = new ethers.Contract(tokenContractAddress, tokenABI, signer);
      const allowance = await tokenContract.allowance(ownerAddress, spenderAddress);
      return ethers.utils.formatUnits(allowance, 18); // Convert from Wei to Ether
    } catch (e) {
      console.error("Error fetching allowance:", e);
      return "0";
    }
  }

// Function to redeem rewards
export async function redeemRewards(signer) {
    const contract = getStakingContract(signer);
    try {
        const tx = await contract.redeem();
        console.log("Transaction sent, waiting for confirmation...");
        return tx;  // Return the transaction object
    } catch (e) {
        console.error("Error redeeming rewards:", e);
        throw e;  // Rethrow the error to be handled by the calling function
    }
}


// Function to withdraw staked tokens
export async function withdrawTokens(amount, signer) {
    const contract = getStakingContract(signer);
    try {
        // Convert the 'amount' from Baby Drac tokens to Wei for the contract.
        const amountInWei = ethers.utils.parseUnits(amount.toString(), 18);
        const tx = await contract.withdraw(amountInWei);
        await tx.wait();
        console.log("Tokens withdrawn successfully!");
        return { success: true };
    } catch (e) {
        console.error("Error withdrawing tokens:", e);
        return { success: false, error: e };
    }
}

// Function to fetch total staked Baby Drac tokens globally
// export async function fetchTotalStakedGlobal() {
//   const contract = getStakingContract(null);
//   try {
//     const totalStaked = await contract.totalStaked(); // Replace with the actual function or variable name
//     return ethers.utils.formatEther(totalStaked);
//   } catch (e) {
//     console.error("Error fetching total staked Baby Drac:", e);
//     return null;
//   }
// }

export async function getTokenInfo() {
  const contract = getStakingContract(null);
  if (!contract) {
    console.error("Contract not initialized.");
    return null;
  }
  
  try {
    const name = await contract.mainToken(); // mainToken address
    const nameTwo = await contract.rewardToken(); // rewardToken address
    const nameThree = await contract.rewardWallet(); // rewardToken address
    console.log("Main Token Address:", name);
    console.log("Reward Token Address:", nameTwo);
    console.log("Reward Wallet Address:", nameThree);
    return { mainToken: name, rewardToken: nameTwo, rewardWallet: nameThree }; // return both addresses
  } catch (e) {
    console.error("Error fetching token addresses:", e);
    return null;
  }
}

// Function to fetch reward per token period from the contract
export async function fetchRewardPerTokenPeriod() {
  const contract = getStakingContract(null);
  if (!contract) {
    console.error("Contract not initialized.");
    return null;
  }

  try {
    const rewardPerToken = await contract.rewardPerTokenPerPeriod();
    return ethers.utils.formatUnits(rewardPerToken, 18); // Adjust according to the token's decimals
  } catch (e) {
    console.error("Error fetching reward per token period:", e);
    return null;
  }
}

// Function to fetch days per period from the contract
export async function fetchDaysPerPeriod() {
  const contract = getStakingContract(null);
  if (!contract) {
    console.error("Contract not initialized.");
    return null;
  }

  try {
    const days = await contract.daysPerPeriod();
    return days.toString(); // Assuming it's a number, not a BigNumber
  } catch (e) {
    console.error("Error fetching days per period:", e);
    return null;
  }
}





  
  

